// extracted by mini-css-extract-plugin
export default {"emptyWrap":"if-empty_emptyWrap__HXMUu","empty":"if-empty_empty__2JRuu","image":"if-empty_image__D1IXM","peeh":"if-empty_peeh__T9NiY","proceed":"if-empty_proceed__iUtUG"};